import React from 'react'
import Overline from './_Overline'
import Superface from '../Superface'

export default class SectionLink extends React.Component {
    
    componentWillMount(){
        this.setState({
            mount : false
        })
    }
    
    componentDidMount(){
        this.timeoutMount = setTimeout( () => {this.setState(
            {...this.state, mount : true}
        )}, 50);
    }

    componentWillUnmout(){
        if(this.timeoutMount) clearTimeout(this.timeoutMount)
        // window.removeEventListener('resize', this.handleResize)
    }


    render(){

        const props = this.props

        const containerStyle = {
            // width:'150px', 
            transformOrigin:'center center', 
            transform: props.rotate || 'none', 
            padding:'0.3rem', 
            fontSize:'0.9rem', 
            position:'relative', 
            textAlign: props.align,
            margin: props.margin,
            width : '150px'
        }

       

        return (
            <a className={"soon nav-item overline-link section-link " + this.props.identifier } style={containerStyle}>
                <span>{props.children}</span>
                <span>{ Superface.translate('Prochainement') }</span>
            </a>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/_SectionLinkSoon.js